var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNdqMissionCompletedMedal = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 36.41 39"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ndq-mission-completed-medal_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 159734",
  fill: "none",
  d: "M0 0h36.41v39H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 28505"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 27619",
  clipPath: "url(#ndq-mission-completed-medal_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36461",
  d: "M6.79 22.499L0 30.824a9.37 9.37 0 001.5.342l6.058-7.427c-.323-.475-.577-.9-.768-1.24",
  fill: "#d14b22"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36462",
  d: "M1.97 31.25l-.468-.085.468.085",
  fill: "#db5827"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36463",
  d: "M9.2 37.13",
  fill: "#db5827"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36464",
  d: "M9.385 37.592l-.176-.439.176.439",
  fill: "#db5827"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36465",
  d: "M12.822 17.284l-1.068-.871-4.964 6.086c.19.341.445.764.768 1.239z",
  fill: "#a83216"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36466",
  d: "M15.626 29.955l-6.235 7.643a9.365 9.365 0 00.636 1.4l6.586-8.074-.42-.491a2.428 2.428 0 00-.567-.479",
  fill: "#d14b22"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36467",
  d: "M16.764 20.501l-3.3-2.694.046.038-5.416 6.639a15.013 15.013 0 006.686 5.1l5.244-6.429.687.56-5.088 6.237a2.424 2.424 0 01.567.48l.42.49 5.168-6.336z",
  fill: "#a83216"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36468",
  d: "M8.094 24.484L2.5 31.342l-.494-.086c2.166.383 5.292.853 5.292.853s.933 2.546 1.715 4.547l5.766-7.069a15.014 15.014 0 01-6.686-5.1",
  fill: "#d14b22"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36469",
  d: "M2.006 31.256l-.036-.006.036.006",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36470",
  d: "M1.5 31.164",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36471",
  d: "M12.822 17.284l.641.523z",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36472",
  d: "M8.094 24.484c-.2-.259-.374-.508-.536-.746L1.5 31.165l.468.085.036.007.494.086z",
  fill: "#f59c0f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36473",
  d: "M8.094 24.484l5.416-6.639-.046-.038-.641-.523-5.264 6.454c.162.238.34.488.536.746",
  fill: "#d67f00"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36474",
  d: "M9.209 37.153L9.2 37.13l.009.023",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36475",
  d: "M9.013 36.659",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36476",
  d: "M9.389 37.599v-.008.008",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36477",
  d: "M15.079 29.697c-.1-.035-.2-.074-.3-.111l-5.766 7.069q.1.242.186.472l.009.024.176.439v.008l6.235-7.643a2.618 2.618 0 00-.541-.258",
  fill: "#f59c0f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36478",
  d: "M15.628 29.956l5.088-6.237-.687-.561-5.244 6.429c.1.037.2.076.3.111a2.634 2.634 0 01.54.258",
  fill: "#d67f00"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36479",
  d: "M27.396 36.658l-.182.461c.06-.149.12-.3.182-.461",
  fill: "#db5827"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36480",
  d: "M21.318 29.199a13.543 13.543 0 007.094-4.6l-5.508-6.753-3.257 2.657-3.355 2.736.1-.08z",
  fill: "#bc431e"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36481",
  d: "M29.73 22.634l-5.074-6.221-1.068.871 5.37 6.583a13.622 13.622 0 00.772-1.234",
  fill: "#bc431e"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36482",
  d: "M34.909 31.165a9.389 9.389 0 001.5-.342l-6.68-8.19a13.541 13.541 0 01-.772 1.234z",
  fill: "#db5827"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36483",
  d: "M27.199 37.155c-.06.151-.119.3-.175.436q.085-.209.175-.436",
  fill: "#db5827"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36484",
  d: "M34.908 31.165l-.467.085.467-.085",
  fill: "#db5827"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36485",
  d: "M18.729 29.613l7.656 9.386a9.383 9.383 0 00.636-1.4l-6.677-8.186a13.518 13.518 0 01-1.615.2",
  fill: "#db5827"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36486",
  d: "M28.408 24.598a13.545 13.545 0 01-7.094 4.6l6.082 7.456c.782-2 1.715-4.547 1.715-4.547s3.125-.469 5.29-.852l-.492.086z",
  fill: "#db5827"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36487",
  d: "M15.699 23.718l-1.068.871 4.1 5.024a13.558 13.558 0 001.615-.2z",
  fill: "#bc431e"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36488",
  d: "M23.588 17.284l-.687.561z",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36489",
  d: "M34.402 31.256l.039-.007-.039.007",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36490",
  d: "M34.91 31.164",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36491",
  d: "M28.958 23.867l-5.37-6.583-.687.561 5.508 6.753q.287-.355.549-.73",
  fill: "#f59c0f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36492",
  d: "M34.909 31.165l-5.952-7.3q-.263.375-.549.73l5.5 6.745.492-.086.039-.007.467-.084",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36493",
  d: "M27.397 36.659",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36494",
  d: "M27.214 37.118l-.012.042.016-.041",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36495",
  d: "M27.022 37.6z",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36496",
  d: "M15.699 23.719l.59-.481z",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36497",
  d: "M20.345 29.411l6.677 8.185.175-.436.016-.041c.059-.149.12-.3.182-.461l-6.082-7.456c-.319.084-.643.154-.97.214",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36498",
  d: "M21.315 29.2l-4.928-6.042-.1.08-.59.481 4.646 5.7c.327-.061.651-.131.97-.214",
  fill: "#f59c0f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36499",
  d: "M18.641 3.295a10.681 10.681 0 017.6 3.165 10.708 10.708 0 10-15.627 14.63 10.707 10.707 0 018.032-17.8",
  fill: "#ffd469"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36500",
  d: "M26.241 6.464a10.708 10.708 0 01-15.627 14.63 10.708 10.708 0 1015.627-14.63",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36501",
  d: "M11.554 21.931a10.7 10.7 0 0015.5-14.4z",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36502",
  d: "M26.237 6.459A10.708 10.708 0 0010.61 21.09a10.792 10.792 0 00.944.841l15.5-14.4a10.826 10.826 0 00-.822-1.074",
  fill: "#ffc32c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36503",
  d: "M29.9 11.639l1.45-1.348a13.426 13.426 0 00-.794-2.3l-1.321 1.227a11.745 11.745 0 01.665 2.419",
  fill: "#ffcc29"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36504",
  d: "M10.648 22.661l-1.249 1.161a13.57 13.57 0 002.368 1.633l1.321-1.228a11.891 11.891 0 01-2.44-1.566",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36505",
  d: "M6.761 16.627l-1.377 1.28a13.554 13.554 0 004.011 5.915l1.249-1.161a11.872 11.872 0 01-3.883-6.034",
  fill: "#ffcc29"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36506",
  d: "M13.088 24.227l-1.321 1.228a13.486 13.486 0 002.237.958l1.451-1.349a11.754 11.754 0 01-2.367-.837",
  fill: "#ffcc29"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36507",
  d: "M29.236 9.22l1.32-1.227a13.556 13.556 0 00-1.452-2.485l-1.252 1.164a11.824 11.824 0 011.384 2.548",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36508",
  d: "M29.9 11.64a11.842 11.842 0 01-14.445 13.426l-1.451 1.348a13.541 13.541 0 0017.345-16.122z",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36509",
  d: "M6.356 13.54A11.844 11.844 0 0122.119 2.358l1.38-1.283a13.541 13.541 0 00-18.11 16.831l1.377-1.28a11.818 11.818 0 01-.41-3.086",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36510",
  d: "M27.852 6.673l1.252-1.164a13.584 13.584 0 00-5.606-4.434l-1.38 1.283a11.9 11.9 0 015.734 4.315",
  fill: "#ffcc29"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36511",
  d: "M17.867 1.304a11.85 11.85 0 1011.85 11.85 11.863 11.863 0 00-11.85-11.85m0 22.565a10.715 10.715 0 1110.715-10.715 10.727 10.727 0 01-10.715 10.715",
  fill: "#d67f00"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36512",
  d: "M18.205 1.687a11.85 11.85 0 1011.85 11.85 11.863 11.863 0 00-11.85-11.85m0 22.565A10.715 10.715 0 1128.92 13.537a10.727 10.727 0 01-10.715 10.715",
  fill: "#f59c0f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36513",
  d: "M23.676 11.694l-.188-.047-2.49-.621-1.463-2.341a1.056 1.056 0 00-.5-.418 1.075 1.075 0 00-1.333.418l-1.463 2.341-2.679.668a1.113 1.113 0 00-.567 1.745l1.775 2.115-.193 2.754a1.088 1.088 0 001.484 1.078l2.56-1.034 2.56 1.034a1.082 1.082 0 001.484-1.078l-.192-2.754 1.774-2.115a1.082 1.082 0 00-.567-1.745",
  fill: "#f59c0f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36514",
  d: "M20.585 10.49l-1.463-2.341a1.058 1.058 0 00-.5-.418 1.6 1.6 0 00-.754.432 21.892 21.892 0 00-1.529 2.782s-3.154.556-3.413.694c-.4.215-.457.526-.45 1.1a1.082 1.082 0 00.1.164l1.774 2.115-.192 2.754a1.073 1.073 0 00.62 1.049l8.3-7.709z",
  fill: "#fff18f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36515",
  d: "M12.924 11.639c.258-.137 3.413-.694 3.413-.694a21.856 21.856 0 011.529-2.782 1.6 1.6 0 01.754-.433 1.075 1.075 0 00-1.333.418l-1.463 2.341-2.679.668a1.077 1.077 0 00-.671 1.581c-.007-.574.046-.886.45-1.1",
  fill: "#fffa99"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36516",
  d: "M23.264 11.158l-.188-.047-8.3 7.709a1.062 1.062 0 00.865.03l2.56-1.034 2.56 1.034a1.082 1.082 0 001.484-1.078l-.192-2.754 1.774-2.115a1.082 1.082 0 00-.567-1.745",
  fill: "#ffe164"
})))));
export default __webpack_public_path__ + "static/ndq-mission-completed-medal.6b25d569a49dc543f0d7011ac4e466b9.svg";
export { SvgNdqMissionCompletedMedal as ReactComponent };